export default __webpack_public_path__ + "static/media/puppy.2ebb4947.png";